Ext.namespace('utils.grid.render');

utils.grid.render = (function( $, Ext, window, undefined ){
    var public = new Object();

	public.button = function(value, cellmeta, record, rowIndex, colIndex, store){
		var className = '', icon = '', title = '';
		
		switch (this.dataIndex)
		{
			case 'delete':
				className = 'button-delete fa-A30002 list-button-delete';
				icon = utils.icon('times-circle', '');
				title = '刪除資料';
			break;	
			
			case 'edit':
				className = 'button-edit fa-0027BD list-button-edit';
				icon = utils.icon('pencil-square-o', '');
				title = '編輯資料';
			break;	
			
			case 'top':
				className = 'button-top list-button-top';
				icon = utils.icon('arrow-circle-o-up', '');
				title = '置頂資料';
			break;	
			
			case 'untop':
				if($.php.in_array(record.get("topDate"), ['', 'null', null])) return '';
				
				className = 'button-untop list-button-untop';
				icon = '<span class="fa-stack"><i class="fa fa-arrow-circle-o-up fa-stack-1x"></i><i class="fa fa-ban fa-stack-1x fa-A30002"></i></span>'
				title = '取消置頂';
			break;
		}
		
		return $.php.sprintf(
			'<span title="%s" data-id="%s" class="%s">%s</span>', 
			title, record.get("rowId"), className, icon
		);
	};
	
	public.summary = function(value, cellmeta, record, rowIndex, colIndex, store){
		return $.php.sprintf(
			'<div class="summary-title">%s</div><div class="summary">%s</div>', 
			value, record.get("summary")
		);
	};
		
	public.images = function(value, cellmeta, record, rowIndex, colIndex, store){
		var el = '<div class="thumb"><img src="images/aurora/noimage.png"></div>';
		
		if(!$.php.in_array(value, ['', 'null', null]))
		{
			el = $.php.sprintf(
				'<div class="thumb"><a href="%s" class="fancybox"><img src="%s"></a></div>', 
				record.get("bigMedia"), value
			);
		}
		
		return el;
	};

	public.flags = function(value, cellmeta, record, rowIndex, colIndex, store){
		return $.php.sprintf(
			'<img src="../../assets/admin/images/flags/%s.png" width="30">', value
		);
	};
	
	public.links = function(value, cellmeta, record, rowIndex, colIndex, store){
		return $.php.sprintf(
			'<a class="bulletin list-button-bulletin" href="%s" target="_blank">%s</a>',
			value, value
		);
	};
	
	public.enable = function(value, cellmeta, record){
		var title = '點選後立即更換狀態';
		var enable, data = app.config.options.enable.data;
		
		enable = data[value];
					
		return $.php.sprintf(
			'<span title="%s" data-id="%s" class="%s list-button-status icon-status"></span>', 
			title, record.get("rowId"), enable.cls
		);
	};
    
    return public;
}( jQuery, Ext, window ));


